import React from "react";
import { Card } from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

//Main components
import MenuButtons from "./subcomponents/MenuButtons";
import QuickRepliesContent from "./subcomponents/QuickRepliesContent";
import "../../../../assets/scss/custom.scss"

const QuickReplies = ({ style, skillId, shwoChat, onClick }) => {
  return (
    <Card className=" user-chat h-100 client-info-card" style={style}>
      <MenuButtons />
      <div
        className="chat-conversation pl-3 h-100"
        style={{
          overflow: "auto",
        }}
      >
        <PerfectScrollbar className="quickRepliesScrollbar">
          <ul className="list-unstyled">
            <QuickRepliesContent
              skillId={skillId}
              shwoChat={shwoChat}
              onClick={onClick}
            />
          </ul>
        </PerfectScrollbar>
      </div>{" "}
    </Card>
  );
};
export default QuickReplies;
